export default __webpack_public_path__ + "static/media/step5DarkModed.aa178656.svg";